import { d as dayjs } from "./dayjs.min-BUYAusmZ.js";
import React__default, { useState, useMemo } from "react";
import { c as commonjsGlobal, g as getDefaultExportFromCjs } from "./_commonjsHelpers-CcAunmGO.js";
import { DateRangePopover } from "./src/components/DateRange/DateRangePopover/DateRangePopover.js";
import { formatDateRange } from "./src/utils/functions/formatDateRange.js";
import { noop } from "./src/utils/functions/noop.js";
import DateRangeDropdown from "./src/components/DateRange/DateRangeDropdown.js";
import { ThemeProvider } from "./src/components/DateRange/theme.js";
var advancedFormat$1 = { exports: {} };
(function(module, exports) {
  !function(e, t) {
    module.exports = t();
  }(commonjsGlobal, function() {
    return function(e, t) {
      var r = t.prototype, n = r.format;
      r.format = function(e2) {
        var t2 = this, r2 = this.$locale();
        if (!this.isValid()) return n.bind(this)(e2);
        var s = this.$utils(), a = (e2 || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e3) {
          switch (e3) {
            case "Q":
              return Math.ceil((t2.$M + 1) / 3);
            case "Do":
              return r2.ordinal(t2.$D);
            case "gggg":
              return t2.weekYear();
            case "GGGG":
              return t2.isoWeekYear();
            case "wo":
              return r2.ordinal(t2.week(), "W");
            case "w":
            case "ww":
              return s.s(t2.week(), "w" === e3 ? 1 : 2, "0");
            case "W":
            case "WW":
              return s.s(t2.isoWeek(), "W" === e3 ? 1 : 2, "0");
            case "k":
            case "kk":
              return s.s(String(0 === t2.$H ? 24 : t2.$H), "k" === e3 ? 1 : 2, "0");
            case "X":
              return Math.floor(t2.$d.getTime() / 1e3);
            case "x":
              return t2.$d.getTime();
            case "z":
              return "[" + t2.offsetName() + "]";
            case "zzz":
              return "[" + t2.offsetName("long") + "]";
            default:
              return e3;
          }
        });
        return n.bind(this)(a);
      };
    };
  });
})(advancedFormat$1);
var advancedFormatExports = advancedFormat$1.exports;
const advancedFormat = /* @__PURE__ */ getDefaultExportFromCjs(advancedFormatExports);
const DateRange = ({
  dateRangeCap,
  filters,
  setFilters,
  dateRangeOptions,
  setDateRange = noop,
  onSearch = noop,
  style = {}
}) => {
  dayjs.extend(advancedFormat);
  const [popoverAnchorEl, setPopoverAnchorEl] = useState();
  const close = () => setPopoverAnchorEl(void 0);
  const updateDates = (startDate, endDate, dateRange) => {
    setFilters({
      startDate,
      endDate,
      dateRange: dateRange === 0 ? Math.floor(dayjs(endDate).diff(startDate, "days", true)) + 1 : dateRange
    });
    onSearch();
    close();
  };
  const updateDateRange = (dateRange) => {
    setDateRange(dateRange);
    onSearch();
    close();
  };
  const optionIsCustomValue = dateRangeOptions.some((option) => option.value === (filters == null ? void 0 : filters.value));
  const optionIsInList = dayjs().isSame(filters == null ? void 0 : filters.endDate, "day") && dateRangeOptions.some((option) => option.value === (filters == null ? void 0 : filters.dateRange)) || optionIsCustomValue;
  const items = useMemo(() => {
    return dateRangeOptions == null ? void 0 : dateRangeOptions.map((option) => ({
      ...option,
      label: option == null ? void 0 : option.name
    }));
  }, [dateRangeOptions]);
  return /* @__PURE__ */ React__default.createElement(ThemeProvider, null, /* @__PURE__ */ React__default.createElement(
    DateRangeDropdown,
    {
      items,
      style: (style == null ? void 0 : style.dropdown) ?? {},
      value: filters.value ?? filters.dateRange,
      onSelect: (newValue, _e, dropdownRef) => {
        if (newValue === 0) {
          setPopoverAnchorEl(dropdownRef.current);
        } else {
          updateDateRange(newValue);
        }
      },
      valueOverride: !optionIsInList ? formatDateRange(filters == null ? void 0 : filters.startDate, filters == null ? void 0 : filters.endDate) : null,
      onFocus: () => {
      },
      onBlur: () => {
      },
      disabled: false
    }
  ), ((filters == null ? void 0 : filters.startDate) || (filters == null ? void 0 : filters.endDate)) && /* @__PURE__ */ React__default.createElement(
    DateRangePopover,
    {
      dateRangeCap,
      onClose: close,
      onSearch: updateDates,
      popoverAnchorEl,
      filters
    }
  ));
};
export {
  DateRange as D,
  advancedFormat as a
};
//# sourceMappingURL=DateRange-Bedd8-E0.js.map
